import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance9000 } from "../../api/axiosInstance";
import { normalizeApiError } from "../../api/apiError";

export const loginInsured = createAsyncThunk(
  "auth/loginInsured",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.post("/api/auth/insured/login", {
        username,
        password,
      });
      if (!response.data?.data?.token) {
        throw new Error("Server tidak mengirim token autentikasi.");
      }
      return response.data;
    } catch (err) {
      return rejectWithValue(normalizeApiError(err));
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.post("/api/auth/login", {
        username,
        password,
      });
      if (!response.data?.token) {
        throw new Error("Server tidak mengirim token autentikasi.");
      }
      return response.data;
    } catch (err) {
      return rejectWithValue(normalizeApiError(err));
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.token = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      })
      .addCase(loginInsured.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginInsured.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.data?.token ?? null;
      })
      .addCase(loginInsured.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
